// src/components/Footer.js

import React from 'react';
import { BsTelephoneFill, BsGeoAltFill, BsInstagram, BsYoutube } from 'react-icons/bs';
import logoImage from '../assets/logo.png'; 

// Le composant reçoit la fonction pour ouvrir les mentions légales via les props
const Footer = ({ onLegalClick }) => {
    return (
        <footer id="contact" className="footer-main">
            <div className="footer-content">
                <div className="footer-top">
                    <div className="footer-logo-area">
                        <img src={logoImage} alt="TechniServices Logo" />
                        <div className="footer-logo-text">
                            <h4>TechniServices</h4>
                            <p>Électricité & Multiservices</p>
                        </div>
                    </div>
                    <nav className="footer-nav">
                        <ul>
                            <li><a href="/#hero">Accueil</a></li>
                            <li><a href="/#services">Services</a></li>
                            <li><a href="/#pourquoi">À Propos</a></li>
                            <li><a href="/#devis">Contact</a></li>
                        </ul>
                    </nav>
                    <div className="footer-cta">
                        <a href="#devis">⚡ Demander un Devis</a>
                    </div>
                </div>

                <hr className="footer-separator" />

                <div className="footer-bottom">
                    <div className="footer-credits">
                        <p>Copyright © {new Date().getFullYear()} TechniServices. Tous droits réservés.</p>
                        <p>
                            <a href="#mentions-legales" onClick={onLegalClick}>Mentions légales</a>
                        </p>
                    </div>
                    <div className="footer-contact-info">
                        <div className="contact-item">
                            <BsTelephoneFill />
                            <span>06 92 14 28 03</span>
                        </div>
                        <div className="contact-item">
                            <BsGeoAltFill />
                            <span>70 Chemin Dassy, 97430 Le Tampon</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <div className="contact-item">
                                <a href="https://www.instagram.com/techniservices.re/" target="_blank" rel="noopener noreferrer" className="instagram-animated-btn">
                                    <BsInstagram className="icon" />
                                    <span>@techniservices.re</span>
                                </a>
                            </div>
                            <div className="contact-item">
                                <a href="https://www.youtube.com/@TechniServices974" target="_blank" rel="noopener noreferrer" className="youtube-animated-btn">
                                    <BsYoutube className="icon" />
                                    <span>@TechniServices974</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;